module.exports = __webpack_public_path__ + "static/media/pool.ecff5068.svg";